import * as React from 'react';
import { TerminalCredential } from 'services/clients/credentials';
import { ActionDropdown } from './ActionDropdown';
import { AddButton } from './AddButton';
import { ActionHandler } from '../../../../actions';

interface Props {
  credential: TerminalCredential;
  onAction: ActionHandler;
  onCreate: (credential: TerminalCredential) => void;
}

export const ActionColumn: React.FC<Props> = (props) => {
  const { credential, onAction, onCreate } = props;

  if (credential.status === 'missing') {
    return <AddButton credential={credential} onCreate={onCreate} />;
  }

  return <ActionDropdown credential={credential} onAction={onAction} />;
};
